import { Drawer, Loading, Tabs } from "@components";
import { If } from "@components/control-statements";
import OcdpAPI from "@providers/OcdpAPI";
import { useEffect, useState } from "react";
import { CustomerCoupons } from "./CustomerDrawer/CustomerCoupons";
import { CustomerFidelity } from "./CustomerDrawer/CustomerFidelity";
import { Data } from "./CustomerDrawer/Data";
import { HistoryTab } from "./CustomerDrawer/HistoryTab";
import { UserStorage } from "shared/tools/UserStorage";
import ROLES from "data/Roles";
import { OlgaEnvironmentsAPI } from "providers/OlgaEnvironmentsAPI";
import { CashbackProgramAPI } from "providers/CashbackProgramAPI";

const tabs = {
  DATA: {
    key: "DATA",
    name: "Dados",
  },
  HISTORIC: {
    key: "HISTORIC",
    name: "Histórico",
  },
  FIDELITY: {
    key: "FIDELITY",
    name: "Fidelidade",
  },
  COUPONS: {
    key: "COUPONS",
    name: "Cupons",
  },
};

export const CustomerDrawer = ({
  visible,
  brandId,
  unitId,
  customerId,
  onClose,
}) => {
  const [loading, setLoading] = useState(false);
  const [customer, setCustomer] = useState({});
  const [activeTab, setActiveTab] = useState(tabs.DATA.key);

  // const showFidelityTab = [ROLES.SUPPORT].includes(
  //   UserStorage.getLoggedUser()?.role
  // );
  // const showCouponsTab = [ROLES.SUPPORT].includes(
  //   UserStorage.getLoggedUser()?.role
  // );

  const loadCustomer = async () => {
    setLoading(true);

    const ocdp = new OcdpAPI();
    const customer = await ocdp.infos(customerId, {
      brand_id: brandId,
      unit_id: unitId,
    });

    setCustomer(customer);

    setCustomer(customer);
    setActiveTab(tabs.DATA.key);
    setLoading(false);
  };

  useEffect(() => {
    if (visible) loadCustomer();
  }, [visible]);

  // useEffect(() => {
  //   if (!showFidelityTab) {
  //     delete tabs.FIDELITY;
  //   }

  //   if (!showCouponsTab) {
  //     delete tabs.COUPONS;
  //   }
  // }, [showFidelityTab, showCouponsTab]);

  return (
    <Drawer
      visible={visible}
      onClose={onClose}
      withoutScroll
      title="Informações sobre cliente"
    >
      <If cond={loading}>
        <div className="w-100 h-100 d-flex align-center justify-center">
          <Loading fullScreen />
        </div>
      </If>
      <If cond={!loading}>
        <Tabs
          activeTab={activeTab}
          onTabSelected={(i) => setActiveTab(i)}
          tabs={Object.values(tabs)}
          full
          show={!loading}
        />
        <If cond={!loading}>
          <If cond={activeTab === tabs.DATA.key}>
            <Data customer={customer} loadCustomer={loadCustomer} />
          </If>
          <If cond={activeTab === tabs.HISTORIC.key}>
            <HistoryTab customer={customer} brandId={brandId} unitId={unitId} loadCustomer={loadCustomer} />
          </If>
          <If cond={activeTab === tabs.FIDELITY?.key}>
            <CustomerFidelity
              customer={customer}
              brandId={brandId}
              unitId={unitId}
            />
          </If>
          <If cond={activeTab === tabs.COUPONS?.key}>
            <CustomerCoupons
              customer={customer}
              brandId={brandId}
              unitId={unitId}
            />
          </If>
        </If>
      </If>
    </Drawer>
  );
};
